import cloudIcon from "@assets/images/cloud.svg";
import { Button, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useHistory } from "react-router";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "420px",
      padding: "43px 32px 32px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.6rem"
    },
    cloudIcon: {
      width: 56,
      height: 56,
      marginBottom: "2.7rem"
    },
    des: {
      marginBottom: "1.6rem",
      textAlign: "center"
    },
    errorcode: {
      color: theme.palette.grey[500],
      marginBottom: "1.6rem"
    },
    btnSubmit: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      borderRadius: "4px",
      width: "100%",
      padding: "12px",

      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    }
  }),

  { name: "SubmitOrderFailed" }
);

const SubmitOrderFailed: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <Paper className={classes.root}>
      <img src={cloudIcon} alt="" className={classes.cloudIcon} />
      <MyTypography variant="h6" className={classes.caption}>
        ไม่สามารถทำรายการได้
      </MyTypography>
      <MyTypography variant="body2" className={classes.des}>
        เนื่องจากไม่สามารถติดต่อระบบได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง
      </MyTypography>
      <Button onClick={handleBack} className={classes.btnSubmit}>
        <MyTypography variant="body1">ตกลง</MyTypography>
      </Button>
    </Paper>
  );
};

export default SubmitOrderFailed;
